import { render, staticRenderFns } from "./TableScannerComponent.vue?vue&type=template&id=53497534&scoped=true"
import script from "./TableScannerComponent.vue?vue&type=script&lang=js"
export * from "./TableScannerComponent.vue?vue&type=script&lang=js"
import style0 from "./TableScannerComponent.vue?vue&type=style&index=0&id=53497534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53497534",
  null
  
)

export default component.exports